import { CheckIndexedDBIsSupport } from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import {
  BroadcastAuthenticatedNotificationStatus,
  BroadcastDisconnectNotificationAllTab,
  BroadcastIsUpdateIsSeenNotificationList,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateNotificationList,
  BroadcastIsUpdateUnSeenNotificationList,
} from "@/broadcastChannel/userChannel";
import { AuthenticatedNotification, LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import {
  ClearTimerCheckAccessToken,
  DoAddNotificationCount,
  DoAddReadNotificationList,
  DoAddUnreadNotificationList,
  DoDeleteNotificationByIdFromSOCKET,
  DoGetNotificationCount,
  DoGetReadAllNotificationList,
  DoGetUnreadAllNotificationList,
  DoSetNotificationIsSeenAllFromSOCKET,
  DoSetNotificationIsSeenByIdFromSOCKET,
  RemoveSocketSessionIdFromCookies,
  SetIsSeenForNotification,
  SetSocketSessionIdFromCookies,
  SetTimerCheckAccessToken,
  SocketAuthentication,
} from "@/helper/notificationHelper";
import { IsMasterTabAvailable } from "@/helper/tabHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { NotificationMessageModel } from "@/model/notification/NotificationMessageModel";
import API from "@/service/Index";
import { ConvertToAssetTemplateCodeList } from "@/service/asset/assetFacade";
import { ConvertToProductTemplateCodeList } from "@/service/product/productFacade";
import { ConvertToTransactionNumberList } from "@/service/transaction/transactionFacade";
import { ConvertToUserDetailList } from "@/service/user/userFacade";
import store from "@/store/index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Notification extends VuexModule {
  public notificationIsConnect = false;
  public notificationReadyToUse = false;
  public notificationIsAuthenticated = false;
  public notificationList: Array<NotificationMessageModel> = [];
  public notificationCount = 0;
  public notificationListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public notificationCountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public unSeenNotificationList: Array<NotificationMessageModel> = [];
  public isSeenNotificationList: Array<NotificationMessageModel> = [];
  public userIdListForMap: Map<number, any> = new Map();
  public transactionTypeListForMap: Map<number, any> = new Map();
  public productCodeListForMap: Map<number, any> = new Map();
  public assetTemplateCodeListForMap: Map<number, any> = new Map();

  get getNotificationList(): Array<NotificationMessageModel> {
    return this.notificationList;
  }

  get getUnSeenNotificationList(): Array<NotificationMessageModel> {
    return this.unSeenNotificationList;
  }

  get getIsSeenNotificationList(): Array<NotificationMessageModel> {
    return this.isSeenNotificationList;
  }

  get getNotificationCount(): number {
    return this.notificationCount;
  }

  get getNotificationIsConnect(): boolean {
    return this.notificationIsConnect;
  }

  get getNotificationReadyToUse(): boolean {
    return this.notificationReadyToUse;
  }

  get getNotificationIsAuthenticated(): boolean {
    return this.notificationIsAuthenticated;
  }

  get getNotificationListLoadingStatus(): LoadingStatusType {
    return this.notificationListLoadingStatus;
  }

  get getNotificationCountLoadingStatus(): LoadingStatusType {
    return this.notificationCountLoadingStatus;
  }

  get getUserIdListForMap(): Map<number, any> {
    return this.userIdListForMap;
  }
  get getTransactionTypeListForMap(): Map<number, any> {
    return this.transactionTypeListForMap;
  }
  get getProductCodeListForMap(): Map<number, any> {
    return this.productCodeListForMap;
  }
  get getAssetTemplateCodeListForMap(): Map<number, any> {
    return this.assetTemplateCodeListForMap;
  }

  @Mutation
  public MutationSetNotificationListLoadingStatus(status: LoadingStatusType) {
    this.notificationListLoadingStatus = status;
  }

  @Mutation
  public MutationSetNotificationCountLoadingStatus(status: LoadingStatusType) {
    this.notificationCountLoadingStatus = status;
  }

  /* eslint-disable @typescript-eslint/camelcase */
  @Mutation
  public SOCKET_authenticated(payload: any) {
    if (payload) {
      this.notificationIsAuthenticated = true;
      this.notificationReadyToUse = true;
      SetSocketSessionIdFromCookies();
      SetTimerCheckAccessToken();
      BroadcastAuthenticatedNotificationStatus(AuthenticatedNotification.Success);
      BroadcastDisconnectNotificationAllTab();
    } else {
      this.notificationReadyToUse = false;
      RemoveSocketSessionIdFromCookies();
      BroadcastAuthenticatedNotificationStatus(AuthenticatedNotification.Failed);
    }
  }
  /* eslint-disable @typescript-eslint/camelcase */
  @Mutation
  public SOCKET_connect() {
    this.notificationIsConnect = true;
    SocketAuthentication();
  }
  /* eslint-disable @typescript-eslint/camelcase */
  @Mutation
  public SOCKET_disconnect() {
    this.notificationIsConnect = false;
    this.notificationIsAuthenticated = false;
    ClearTimerCheckAccessToken();
    if (!IsMasterTabAvailable()) {
      this.notificationReadyToUse = false;
    }
  }
  /* eslint-disable @typescript-eslint/camelcase */
  @Mutation
  public async SOCKET_GetNotificationCount(payload: any) {
    store.dispatch("Notification/ActionSOCKETGetNotificationCount", payload, { root: true });
  }

  @Mutation
  public async SOCKET_RemoveNotificationById(payload: any) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      DoDeleteNotificationByIdFromSOCKET(payload.merchantId, payload.notificationId);
    }
  }

  @Mutation
  public async SOCKET_IsSeenNotificationById(payload: any) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      DoSetNotificationIsSeenByIdFromSOCKET(payload.merchantId, payload.notificationId);
    }
  }

  @Mutation
  public async SOCKET_IsSeenAllNotification(payload: any) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      DoSetNotificationIsSeenAllFromSOCKET(payload.merchantId);
    }
  }

  @Mutation
  public MutationSetNotificationReadyToUse(status: boolean) {
    this.notificationReadyToUse = status;
  }

  @Mutation
  public MutationSetNotificationCount(count: number) {
    this.notificationCount = count;
  }

  @Mutation
  public MutationSetNotificationList(notificationList: Array<NotificationMessageModel>) {
    this.notificationList = notificationList;
  }

  @Mutation
  public MutationSetUnSeenNotificationList(notificationList: Array<NotificationMessageModel>) {
    this.unSeenNotificationList = notificationList;
  }

  @Mutation
  public MutationSetIsSeenNotificationList(notificationList: Array<NotificationMessageModel>) {
    this.isSeenNotificationList = notificationList;
  }

  @Mutation
  public MutationSetUserIdListForMap(userDetailList: any) {
    if (userDetailList && userDetailList.length > 0) {
      for (const userDetail of userDetailList) {
        this.userIdListForMap.set(userDetail.userId, userDetail);
      }
    }
  }

  @Mutation
  public MutationProductCodeIdListForMap(productTemplateCodeList: any) {
    if (productTemplateCodeList && productTemplateCodeList.length > 0) {
      for (const productTemplateCode of productTemplateCodeList) {
        this.productCodeListForMap.set(productTemplateCode.id, productTemplateCode);
      }
    }
  }

  @Mutation
  public MutationSetAssetTemplateCodeListForMap(assetTemplateCodeList: any) {
    if (assetTemplateCodeList && assetTemplateCodeList.length > 0) {
      for (const assetTemplateCode of assetTemplateCodeList) {
        this.assetTemplateCodeListForMap.set(assetTemplateCode.id, assetTemplateCode);
      }
    }
  }

  @Mutation
  public MutationSetTransactionTypeListForMap(input: any) {
    const transactionNumberList = input.transactionNumberList;
    const transactionType = input.transactionType;

    if (transactionNumberList && transactionNumberList.length > 0) {
      let transactionCodeForMap = new Map();
      const transactionTypeOnLocal = this.transactionTypeListForMap.get(transactionType);
      if (transactionTypeOnLocal) {
        transactionCodeForMap = transactionTypeOnLocal;
      }

      for (const transactionNumber of transactionNumberList) {
        transactionCodeForMap.set(transactionNumber.id, transactionNumber);
      }

      this.transactionTypeListForMap.set(transactionType, transactionCodeForMap);
    }
  }

  @Action
  public async ActionSOCKETGetNotificationCount(payload: any) {
    this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      await DoAddNotificationCount(payload.merchantId, payload.notificationCount);
      if (payload.merchantId == merchantId) {
        const count = await DoGetNotificationCount(merchantId);
        this.context.commit("MutationSetNotificationCount", count);
      }
      BroadcastIsUpdateNotificationCount(payload.merchantId);
    } else {
      this.context.commit("MutationSetNotificationCount", payload.notificationCount);
    }
    setTimeout(() => {
      this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public async ActionSetNotificationListFromIndexedDB() {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    const notificationList = [
      ...SetIsSeenForNotification(unreadNotificationList, false),
      ...SetIsSeenForNotification(readNotificationList, true),
    ];

    this.context.commit("MutationSetNotificationList", notificationList);

    setTimeout(() => {
      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public async ActionSetNotificationCountFromIndexedDB() {
    this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    const count = await DoGetNotificationCount(merchantId);
    this.context.commit("MutationSetNotificationCount", count);
    setTimeout(() => {
      this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public DoGetUnseenNotificationCount(notificationMerchantId: number) {
    this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Loading);
    API.NotificationService.DoGetUnseenNotificationCount(notificationMerchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        const merchantId = MerchantId();
        const notificationCount = res.data.notificationCount;

        if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
          await DoAddNotificationCount(notificationMerchantId, notificationCount);
          if (notificationMerchantId == merchantId) {
            const count = await DoGetNotificationCount(merchantId);
            this.context.commit("MutationSetNotificationCount", count);
          }
          BroadcastIsUpdateNotificationCount(notificationMerchantId);
        } else {
          this.context.commit("MutationSetNotificationCount", notificationCount);
        }
      }
      this.context.commit("MutationSetNotificationCountLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  public DoGetAllNotificationList(notificationMerchantId: number) {
    const doGetUnseenNotificationList = API.NotificationService.DoGetUnseenNotificationList(
      notificationMerchantId
    ).then((res) => {
      if (res.status.IsSuccess()) {
        const unreadNotificationList = [...res.data.list];
        return unreadNotificationList;
      }
    });

    const doGetSeenNotificationList = API.NotificationService.DoGetSeenNotificationList(notificationMerchantId).then(
      (res) => {
        if (res.status.IsSuccess()) {
          const readNotificationList = [...res.data.list];
          return readNotificationList;
        }
      }
    );

    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);

    Promise.all([doGetUnseenNotificationList, doGetSeenNotificationList]).then(async (results) => {
      const unreadNotificationListFromAPI: any = results[0];
      const readNotificationListFromAPI: any = results[1];
      const merchantId = MerchantId();

      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        await DoAddUnreadNotificationList(notificationMerchantId, unreadNotificationListFromAPI);
        await DoAddReadNotificationList(notificationMerchantId, readNotificationListFromAPI);
        if (notificationMerchantId == merchantId) {
          const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
          const readNotificationList = await DoGetReadAllNotificationList(merchantId);
          const notificationList = [
            ...SetIsSeenForNotification(unreadNotificationList, false),
            ...SetIsSeenForNotification(readNotificationList, true),
          ];

          this.context.commit("MutationSetNotificationList", notificationList);
        }
        BroadcastIsUpdateNotificationList(notificationMerchantId);
      } else {
        const notificationList = [
          ...SetIsSeenForNotification(unreadNotificationListFromAPI, false),
          ...SetIsSeenForNotification(readNotificationListFromAPI, true),
        ];
        this.context.commit("MutationSetNotificationList", notificationList);
      }

      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  DoGetUnSeenNotificationList(notificationMerchantId: number) {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    API.NotificationService.DoGetUnseenNotificationList(notificationMerchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        let unreadNotificationList = [...res.data.list];
        const merchantId = MerchantId();
        if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
          await DoAddUnreadNotificationList(notificationMerchantId, unreadNotificationList);
          if (notificationMerchantId == merchantId) {
            unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
            const notificationList = [...SetIsSeenForNotification(unreadNotificationList, false)];
            this.context.commit("MutationSetUnSeenNotificationList", notificationList);
          }
          BroadcastIsUpdateUnSeenNotificationList(notificationMerchantId);
        } else {
          const notificationList = [...SetIsSeenForNotification(unreadNotificationList, false)];
          this.context.commit("MutationSetUnSeenNotificationList", notificationList);
        }
      }

      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  DoGetIsSeenNotificationList(notificationMerchantId: number) {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    API.NotificationService.DoGetSeenNotificationList(notificationMerchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        let readNotificationList = [...res.data.list];
        const merchantId = MerchantId();
        if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
          await DoAddReadNotificationList(notificationMerchantId, readNotificationList);
          if (notificationMerchantId == merchantId) {
            readNotificationList = await DoGetReadAllNotificationList(merchantId);
            const notificationList = [...SetIsSeenForNotification(readNotificationList, true)];
            this.context.commit("MutationSetIsSeenNotificationList", notificationList);
          }
          BroadcastIsUpdateIsSeenNotificationList(notificationMerchantId);
        } else {
          const notificationList = [...SetIsSeenForNotification(readNotificationList, true)];
          this.context.commit("MutationSetIsSeenNotificationList", notificationList);
        }
      }

      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  public DoDeleteUnseenNotification(input: { merchantId: number; notificationId: string }) {
    API.NotificationService.DoDeleteUnseenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: TypeComponentNoti.error,
          },
          { root: true }
        );
      }
    });
  }

  @Action
  public DoDeleteSeenNotification(input: { merchantId: number; notificationId: string }) {
    API.NotificationService.DoDeleteSeenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: TypeComponentNoti.error,
          },
          { root: true }
        );
      }
    });
  }

  @Action
  public DoSetAllNotificationIsSeen(merchantId: number) {
    API.NotificationService.DoSetAllNotificationIsSeen(merchantId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: TypeComponentNoti.error,
          },
          { root: true }
        );
      }
    });
  }

  @Action
  public DoSetNotificationIsSeen(input: any) {
    API.NotificationService.DoSetNotificationIsSeen(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: TypeComponentNoti.error,
          },
          { root: true }
        );
      }
    });
  }

  @Action
  public async ActionSetNotificationFromActionIsSeen() {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    const notificationCount = await DoGetNotificationCount(merchantId);
    this.context.commit("MutationSetNotificationCount", notificationCount);

    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
    this.context.commit("MutationSetUnSeenNotificationList", unreadNotificationList);

    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = SetIsSeenForNotification(readNotificationList, true);
    this.context.commit("MutationSetIsSeenNotificationList", readNotificationList);

    setTimeout(() => {
      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public async ActionSetUnSeenNotificationListFromIndexedDB() {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = SetIsSeenForNotification(unreadNotificationList, false);
    this.context.commit("MutationSetUnSeenNotificationList", unreadNotificationList);

    setTimeout(() => {
      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public async ActionSetIsSeenNotificationListFromIndexedDB() {
    this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Loading);
    const merchantId = MerchantId();
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = SetIsSeenForNotification(readNotificationList, true);
    this.context.commit("MutationSetIsSeenNotificationList", readNotificationList);

    setTimeout(() => {
      this.context.commit("MutationSetNotificationListLoadingStatus", LoadingStatusType.Success);
    }, 0);
  }

  @Action
  public DoGetUserByUserId(_userIdList: Array<number>) {
    return new Promise((resolve) => {
      const userIdList = [...new Set(_userIdList)];

      let userIdListForSearch: Array<number> = [];

      if (this.userIdListForMap && this.userIdListForMap.size > 0) {
        userIdList.forEach((userId) => {
          const userOnLocal = this.userIdListForMap.get(userId);
          if (!userOnLocal) {
            userIdListForSearch.push(userId);
          }
        });
      } else {
        userIdListForSearch = userIdList;
      }

      if (userIdListForSearch.length > 0) {
        API.UserService.DoGetUserDetailForDisplay(userIdListForSearch).then((res) => {
          if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
            const userDetailList = ConvertToUserDetailList(res.data.userDetailList);
            this.context.commit("MutationSetUserIdListForMap", userDetailList);
            resolve(this.userIdListForMap);
          } else {
            resolve(null);
          }
        });
      } else {
        setTimeout(() => {
          resolve(this.userIdListForMap);
        }, 0);
      }
    });
  }

  @Action
  public DoGetProductCodeForDisplay(_productIdList: Array<number>) {
    return new Promise((resolve) => {
      const productIdList = [...new Set(_productIdList)];

      let productIdListForSearch: Array<number> = [];

      if (this.productCodeListForMap && this.productCodeListForMap.size > 0) {
        productIdList.forEach((productId) => {
          const userOnLocal = this.productCodeListForMap.get(productId);
          if (!userOnLocal) {
            productIdListForSearch.push(productId);
          }
        });
      } else {
        productIdListForSearch = productIdList;
      }

      if (productIdListForSearch.length > 0) {
        API.ProductService.DoGetProductTemplateCodeByProductIdList(productIdListForSearch).then((res) => {
          if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
            const productTemplateCodeList = ConvertToProductTemplateCodeList(res.data.productTemplateCodeList);
            this.context.commit("MutationProductCodeIdListForMap", productTemplateCodeList);
            resolve(this.productCodeListForMap);
          } else {
            resolve(null);
          }
        });
      } else {
        setTimeout(() => {
          resolve(this.productCodeListForMap);
        }, 0);
      }
    });
  }

  @Action
  public DoGetAssetTemplateCodeForDisplay(_assetTemplateIdList: Array<number>) {
    return new Promise((resolve) => {
      const assetTemplateIdList = [...new Set(_assetTemplateIdList)];

      let assetTemplateIdListForSearch: Array<number> = [];

      if (this.assetTemplateCodeListForMap && this.assetTemplateCodeListForMap.size > 0) {
        assetTemplateIdList.forEach((assetTemplateId) => {
          const userOnLocal = this.assetTemplateCodeListForMap.get(assetTemplateId);
          if (!userOnLocal) {
            assetTemplateIdListForSearch.push(assetTemplateId);
          }
        });
      } else {
        assetTemplateIdListForSearch = assetTemplateIdList;
      }

      if (assetTemplateIdListForSearch.length > 0) {
        API.AssetService.DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdListForSearch).then((res) => {
          if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
            const assetTemplateCodeList = ConvertToAssetTemplateCodeList(res.data.assetTemplateCodeList);
            this.context.commit("MutationSetAssetTemplateCodeListForMap", assetTemplateCodeList);
            resolve(this.assetTemplateCodeListForMap);
          } else {
            resolve(null);
          }
        });
      } else {
        setTimeout(() => {
          resolve(this.assetTemplateCodeListForMap);
        }, 0);
      }
    });
  }

  @Action
  public DoGetTransactionNumberForDisplay(input: any) {
    return new Promise((resolve) => {
      const transactionIdList: Array<number> = [...new Set(input.transactionIdList as Array<number>)];
      const transactionType = input.transactionType;

      let transactionIdForSearch: Array<number> = [];

      if (this.transactionTypeListForMap && this.transactionTypeListForMap.size > 0) {
        transactionIdList.forEach((transactionId) => {
          const transactionTypeOnLocal = this.transactionTypeListForMap.get(transactionType);
          if (transactionTypeOnLocal) {
            const transactionCodeOnLocal = transactionTypeOnLocal.get(transactionId);
            if (!transactionCodeOnLocal) {
              transactionIdForSearch.push(transactionId);
            }
          } else {
            transactionIdForSearch.push(transactionId);
          }
        });
      } else {
        transactionIdForSearch = transactionIdList;
      }

      if (transactionIdForSearch.length > 0) {
        API.TransactionService.DoGetTransactionNumberByTransactionId(transactionIdForSearch, transactionType).then(
          (res) => {
            if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
              const transactionNumberList = ConvertToTransactionNumberList(res.data.transactionNumberList);
              this.context.commit("MutationSetTransactionTypeListForMap", { transactionNumberList, transactionType });
              resolve(this.transactionTypeListForMap);
            } else {
              resolve(null);
            }
          }
        );
      } else {
        setTimeout(() => {
          resolve(this.transactionTypeListForMap);
        }, 0);
      }
    });
  }
}
